import React, { useState, useRef, useEffect } from "react";
import Avatar from "../../components/Common/Avatar";
import Button from "../../components/Buttons/Button";
import ChatBubble from "./ChatBubble";

const Chat = ({
  chatsByDate = [],
  users = [],
  loginUserId,
  showInput = false,
  inputMessage = "",
  onInputChange,
  onSendMessage,
  loginUserAvatarUrl = "",
  loginUserAvatarAlt = "user",
  onDeleteMessage,
  onReactMessage,
  emojis = ["👍", "❤️", "😂", "😮", "😢", "🙏"],
  showActions = true,
}) => {
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);
  const [replyTo, setReplyTo] = useState(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chatsByDate]);

  const handleReply = (messageData, sender) => {
    setReplyTo({ message: messageData, sender });
    inputRef.current?.focus();
  };

  const handleCancelReply = () => setReplyTo(null);

  const handleSend = () => {
    onSendMessage?.(replyTo);
    setReplyTo(null);
  };

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 overflow-auto p-4 bg-gray-50">
        {chatsByDate?.map((group, index) => (
          <div key={index} className="flex flex-col">
            <div className="text-center text-[11px] text-gray-400 mb-3">
              {group?.date}
            </div>
            {group?.messages?.map((chat) => {
              const sender = users?.find((u) => u?.id === chat?.senderId);
              return (
                <ChatBubble
                  key={chat?.id}
                  data={chat}
                  sender={sender}
                  loginUserId={loginUserId}
                  onDelete={onDeleteMessage}
                  onReply={handleReply}
                  QUICK_EMOJIS={emojis}
                  showActions={showActions}
                  onReact={onReactMessage}
                />
              );
            })}
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      {showInput && (
        <div className="border-t border-gray-200 bg-white shrink-0">
          {replyTo && (
            <div className="flex items-center gap-2 px-4 pt-2 pb-1">
              <div className="flex-1 flex items-center gap-2 bg-info-50 border-l-2 border-info-400 rounded px-3 py-1.5">
                <svg
                  className="w-3.5 h-3.5 text-info-400 shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
                  />
                </svg>
                <div className="min-w-0">
                  <p className="text-xs font-semibold text-info-600">
                    {replyTo.sender?.name}
                  </p>
                  <p className="text-xs text-gray-500 truncate text-wrap">
                    {replyTo.message?.message}
                  </p>
                </div>
              </div>
              <Button
                type="icon"
                icon={"close"}
                variant="text"
                onClick={handleCancelReply}
              />
            </div>
          )}

          <div className="flex items-center gap-3 px-4 py-3">
            <div className="flex items-center flex-1 bg-gray-100 rounded-full px-3 py-2">
              <Avatar
                size="md"
                alt={loginUserAvatarAlt}
                src={loginUserAvatarUrl}
              />
              <input
                ref={inputRef}
                type="text"
                placeholder={
                  replyTo
                    ? `Replying to ${replyTo.sender?.name}...`
                    : "Add Comment Here..."
                }
                className="flex-1 bg-transparent outline-none px-3 text-sm"
                value={inputMessage}
                onChange={(e) => onInputChange?.(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSend()}
              />
              <Button type="icon" icon="send" size="lg" onClick={handleSend} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Chat;
// import React, { useState, useRef, useEffect } from "react";
// import Avatar from "../../components/Common/Avatar";
// import Button from "../../components/Buttons/Button";
// import { dateFormator } from "../../utils";
// import DropdownMenu from "../Buttons/DropdownMenu";

// const Chat = ({ key, data, sender, loginUserId }) => {
//   const [isHovering, setIsHovering] = useState(false);
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   // Handle clicks outside the dropdown to close it
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsDropdownOpen(false);
//       }
//     };

//     // Add event listener when dropdown is open
//     if (isDropdownOpen) {
//       document.addEventListener("mousedown", handleClickOutside);
//     }

//     // Clean up the event listener
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [isDropdownOpen]);

//   // Toggle dropdown when menu button is clicked
//   const handleMenuClick = () => {
//     setIsDropdownOpen(!isDropdownOpen);
//   };

//   return (
//     <div
//       id={key}
//       className={`flex ${loginUserId === sender.id ? "justify-end" : ""}`}
//       onMouseEnter={() => setIsHovering(true)}
//       onMouseLeave={() => {
//         // Only hide the menu button when hovering out if dropdown is not open
//         if (!isDropdownOpen) {
//           setIsHovering(false);
//         }
//       }}
//     >
//       <div className="w-full max-w-xl flex flex-col gap-3 my-5">
//         <div
//           className={`flex justify-between items-center ${
//             loginUserId === sender.id ? "flex-row-reverse" : ""
//           }`}
//         >
//           <div
//             className={`flex items-center gap-2 ${
//               loginUserId === sender.id ? "flex-row-reverse" : ""
//             }`}
//           >
//             <Avatar size="sm" alt={sender.name} src={sender.profilePhotoUrl} />
//             <div className="font-semibold">{sender.name}</div>
//             <div className="text-xs text-gray-400">
//               {dateFormator(data.timestamp, "time-ampm")}
//             </div>
//           </div>

//           {(isHovering || isDropdownOpen) && (
//             <div ref={dropdownRef}>
//               <DropdownMenu
//                 //menuAlign={loginUserId === sender.id ? "left" : "right"}

//                 MenuSection={
//                   <div className="flex flex-col">
//                     <Button
//                       title={"Option 1"}
//                       variant="text"
//                       color="black"
//                       size="xs-sm"
//                       className="!justify-start py-1"
//                     />
//                     <Button
//                       title={"Option 2"}
//                       variant="text"
//                       color="black"
//                       size="xs-sm"
//                       className="!justify-start py-1"
//                     />
//                   </div>
//                 }
//                 isOpen={isDropdownOpen}
//                 onToggle={handleMenuClick}
//               >
//                 <Button
//                   type="icon"
//                   variant="text"
//                   icon={"menu"}
//                   color="black"
//                   size="xs"
//                   onClick={handleMenuClick}
//                 />
//               </DropdownMenu>
//             </div>
//           )}
//         </div>
//         <div className="border-[1px] border-gray-200 p-3 rounded-md">
//           {data.message}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Chat;
